module.exports = __webpack_public_path__ + "static/media/location_icon.500178d4.svg";